import * as ProtocolConsumptionSyncProcessStore from '../../../../redux/middleware/ProtocolConsumptionSyncProcessMiddleware';
import { SYNC_PROCESS_LOGS_DEFAULT_PAGE_SIZE } from '../../../../redux/middleware/ProtocolConsumptionSyncProcessMiddleware';

import { AppState } from '../../../../redux/reducers';
import { Protocol } from '../../../../models/Entities/Protocols/Protocol';
import { ProtocolConsumptionSyncProcessLog } from '../../../../models/Entities/Protocols/ProtocolConsumptionSyncProcessLog';
import { ErrorType } from '../../../../models/HttpError';
import { PaginationState } from '../../../../models/PaginationState';
import { SyncProcessLogSeverityEnum } from '../../../../models/Enums/SyncProcessLogSeverityEnum';

/** Paginado vacío, para el primer render y para cuando el proceso no tiene logs. */
export const EmptyPaginationState: PaginationState = {
    pageNumber: 1,
    pageSize: SYNC_PROCESS_LOGS_DEFAULT_PAGE_SIZE,
    totalPages: 0,
    totalRecords: 0,
};

interface IProps {
    ProtocolId: number;
    SyncProcessId: string;
    /**
     * Umbral con el que corrió el proceso. Lo que quedó por debajo no se
     * registró, así que la pantalla tiene que decirlo en vez de mostrar un
     * listado vacío como si no hubiera pasado nada.
     */
    MinLogSeverity?: SyncProcessLogSeverityEnum;
    isOpen: boolean;
    onDismiss: () => void;
}

interface ConnectedProps {
    isLoading: boolean;
    successLoading: boolean;
    failureLoading: boolean;
    errorGetting: ErrorType | null;
    /** Sólo la página cargada; el listado lo pagina el servidor. */
    logs: ProtocolConsumptionSyncProcessLog[];
    paginationState: PaginationState;
}

interface DispatchProps {
    GetProtocolConsumptionSyncProcessLogsById: typeof ProtocolConsumptionSyncProcessStore.ActionCreators.GetProtocolConsumptionSyncProcessLogsById;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {
    const protocol = state.MedicalProtocols?.list?.find((item: Protocol) => item.id === ownProps.ProtocolId) || null;
    const logs = protocol?.consumptionsSyncProcessLogsByProcessId?.[ownProps.SyncProcessId] || [];
    const paginationState = protocol?.consumptionsSyncProcessLogsPaginationByProcessId?.[ownProps.SyncProcessId]
        || EmptyPaginationState;

    // No se expone `protocol`: no se usa en la pantalla y el reducer lo
    // reconstruye en cada acción del protocolo. Mientras el proceso corre, el
    // panel de arriba lo consulta cada 5 segundos, así que devolverlo obligaba
    // a redibujar toda la página de logs una vez por poll.
    return {
        paginationState,
        isLoading: state.MedicalProtocols?.isLoadingSyncProcessLogs || false,
        successLoading: state.MedicalProtocols?.LoadingSyncProcessLogsSuccess || false,
        failureLoading: state.MedicalProtocols?.FailGettingSyncProcessLogs || false,
        errorGetting: state.MedicalProtocols?.ErrorGettingSyncProcessLogs || null,
        logs,
    };
};

export const mapDispatchToProps = {
    ...ProtocolConsumptionSyncProcessStore.ActionCreators,
};